import React from 'react'
import SEO from '../components/common/SEO'
import ContactBanner from '../components/contact/ContactBanner'
import ContactInfo from '../components/contact/ContactInfo'
import ContactFormSection from '../components/contact/ContactFormSection'
import GoogleMap from '../components/contact/GoogleMap'
import CTASection from '../components/common/CTASection'

const Contact = () => {
  return (
    <>
      <SEO
        title="Contact AZ Construction | Construction Company in Indore"
        description="Contact AZ Construction for residential construction, commercial projects, property development, and consultation. Visit our office in Khajrana, Indore."
        url="https://azconstruction.com/contact-us"
      />
      <ContactBanner />
      <ContactInfo />
      <ContactFormSection />
      <GoogleMap />
      <CTASection />
    </>
  )
}

export default Contact